import { z } from "zod";
/**
 * Primitives et enveloppes communes partagées par tout le contrat.
 * Alignées sur WEBAPI_SPEC §2 (enveloppe d'erreur) et sur les colonnes prod `etheria_*`.
 */
/** UUID Minecraft (CHAR(36)). Clé de jointure vers toute table etheria_*. */
export const UuidSchema = z.string().uuid();
/** Pseudo Minecraft (1-16, alphanumérique + underscore). */
export const PlayerNameSchema = z
    .string()
    .min(1)
    .max(16)
    .regex(/^[A-Za-z0-9_]+$/);
/**
 * Solde exact : SIEMPRE la colonne TEXT BigDecimal `balance`.
 * `balanceSort` (BIGINT) sert UNIQUEMENT au tri, jamais à l'affichage. (SITE_SPEC §7)
 */
export const MoneySchema = z.string().regex(/^-?\d+(\.\d+)?$/);
/** Epoch millisecondes (BIGINT côté DB). */
export const EpochMillisSchema = z.number().int().nonnegative();
/** Résolveur de cible : ?uuid= OU ?name= (WEBAPI_SPEC §4). */
export const PlayerRefSchema = z
    .object({
    uuid: UuidSchema.optional(),
    name: PlayerNameSchema.optional(),
})
    .refine((v) => v.uuid !== undefined || v.name !== undefined, {
    message: "uuid ou name requis",
});
/** Pagination générique (limit/offset). */
export const PageQuerySchema = z.object({
    limit: z.number().int().min(1).max(200).default(50),
    offset: z.number().int().min(0).default(0),
});
export function pagedSchema(item) {
    return z.object({
        items: z.array(item),
        total: z.number().int().nonnegative(),
        limit: z.number().int().nonnegative(),
        offset: z.number().int().nonnegative(),
    });
}
/**
 * Enveloppe d'erreur uniforme (WEBAPI_SPEC §2).
 * `{ ok:false, error:"<code>", message:"<fr optionnel>" }`.
 */
export const ApiErrorSchema = z.object({
    ok: z.literal(false),
    error: z.string(),
    message: z.string().optional(),
});
/** Enveloppe de succès générique : `{ ok:true, ...data }`. */
export function okSchema(shape) {
    return z.object({ ok: z.literal(true), ...shape });
}
/** Réponse action simple : `{ ok:true }` ou l'enveloppe d'erreur. */
export const ActionOkSchema = z.object({ ok: z.literal(true) });
/** Coordonnées de monde (téléport, homes, claims, zones). */
export const LocationSchema = z.object({
    world: z.string(),
    x: z.number(),
    y: z.number(),
    z: z.number(),
    yaw: z.number().optional(),
    pitch: z.number().optional(),
});
//# sourceMappingURL=common.js.map